import { LS_TEAMS } from '@config/localstorage.js'
import { useLocalStorage } from '@vueuse/core'
import { isArray } from '@helpers/utils.js'
import { computed } from 'vue'

const teamState = useLocalStorage(LS_TEAMS, null)

export default function () {
  const myTeams = computed(() => {
    const teams = JSON.parse(teamState.value)
    return isArray(teams) ? teams : []
  })

  function setMyTeams(teams) {
    teamState.value = JSON.stringify(teams)
  }

  function clearMyTeamsStore() {
    teamState.value = null
  }

  return {
    clearMyTeamsStore,
    setMyTeams,
    myTeams,
  }
}
